import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Card, 
  CardContent, 
  CardActionArea, 
  Typography, 
  Chip, 
  Box, 
  Avatar 
} from '@mui/material';

const InterviewCard = ({ interview }) => {
//   const slug = `${interview.companyName.toLowerCase()}-${interview.jobName.toLowerCase().replace(/\s+/g, '-')}`;
    const slug = `${interview.id}-${interview.companyName.toLowerCase()}-${interview.jobName.toLowerCase().replace(/\s+/g, '-')}`;
  
  return (
    <Card 
      elevation={2} 
      sx={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        transition: 'transform 0.3s, box-shadow 0.3s',
        '&:hover': {
          transform: 'translateY(-8px)',
          boxShadow: 6
        }
      }}
    >
      <CardActionArea 
        component={Link} 
        to={`/topInterview/${slug}`}
        sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'stretch', height: '100%' }}
      >
        <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Avatar 
              src={interview.logo} 
              alt={`${interview.companyName} logo`}
              sx={{ 
                width: 40, 
                height: 40, 
                mr: 2,
                bgcolor: 'white',
                p: 0.5,
                border: '1px solid #eee'
              }}
            />
            <Typography variant="h6" component="h2">
              {interview.companyName}
            </Typography>
          </Box>
          
          <Typography variant="body1" sx={{ fontWeight: 500, mb: 1 }}>
            {interview.jobName}
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, flexGrow: 1 }}>
            {interview.description.length > 120 
              ? `${interview.description.substring(0, 120)}...` 
              : interview.description}
          </Typography>
          
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 'auto' }}>
            {interview.difficulty && (
              <Chip 
                label={interview.difficulty} 
                size="small"
                color={
                  interview.difficulty === "Easy" ? "success" :
                  interview.difficulty === "Medium" ? "warning" : "error"
                }
                variant="outlined"
              />
            )}
            {interview.duration && (
              <Chip 
                label={interview.duration} 
                size="small"
                color="info"
                variant="outlined"
              />
            )}
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default InterviewCard;